angular.module('angus.services').service('inventoryService', [
    '$http',
    function($http) {
        function postInventoryTransactionReport(subscriberKey, params) {
                return $http.post(`api/subscriber/${subscriberKey}/inventory/reports/inventory-transaction`,params, {apiV2: true})
                .then( response => response.data)
                .catch(error => {
                    console.error(`Failed to get inventory results. SubscriberKey: ${subscriberKey};`, error);
                    throw error;
                });
        }

        return {
            postInventoryTransactionReport: postInventoryTransactionReport,
        };
    }
])